module.exports = __webpack_public_path__ + "img/triangle-product-name.12b3893d.svg";